import type { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useInterviewStore } from '../../stores/interview-store.js';

interface ConsentGuardProps {
  children: ReactNode;
}

export function ConsentGuard({ children }: ConsentGuardProps) {
  const { token } = useParams<{ token: string }>();
  const consentGiven = useInterviewStore((s) => s.consentGiven);

  if (!consentGiven) {
    return <Navigate to={`/survey/${token}/consent`} replace />;
  }

  return <>{children}</>;
}
